import { useRegistrationProps } from "@/context/useRegistrationProps";
import { ExistingEmailType } from "@/types/registration";
import { Details } from "@/types/userDetails";
import { getSiteProps } from "@/utils/siteProps";
import { Button, RadioButtonList } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

type ExistingEmailsProps = {
  emails: ExistingEmailType[];
  payload: Details;
  closePopup: (type?: string) => void;
};

const ExistingEmails: React.FC<ExistingEmailsProps> = ({
  emails,
  payload,
  closePopup,
}) => {
  const { hostname } = useRegistrationProps();
  const [selectedEmail, setSelectedEmail] = useState("");
  const siteProps = getSiteProps(hostname);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.id;
    setSelectedEmail(selected);
  };

  const handleSelect = (id: string) => {
    document.getElementById(id)?.click();
  };

  const handleLogin = () => {
    const selectedEmailObj = emails.find(
      (email) => email.uuid === selectedEmail,
    );
    const redirectUrl = `/rio/login?uuid=${selectedEmailObj?.uuid}&username=${payload.countryCode}-${payload.mobileNumber}&email=${selectedEmailObj?.email}`;
    window.location.href = redirectUrl;
    try {
      if (typeof window.MessageHandler?.postMessage === "function") {
        window.MessageHandler.postMessage(
          JSON.stringify({
            type: "REG_LOGIN_REDIRECT",
          }),
        );
      }
    } catch (error) {
      // console.error("Error sending data to Flutter:", error);
    }
  };

  useEffect(() => {
    if (emails?.length === 1) {
      handleSelect(emails[0].uuid);
    }
  }, [emails]);

  const labelStyles =
    "align-center cursor-pointer accent-primary-200 flex w-full flex-row items-center gap-2 text-[12px] [&>input]:h-[14px] [&>input]:w-[14px]";

  const selectedEmailStyles = "!border-brand-primary";

  return (
    <div className="flex flex-col gap-[24px]">
      <p className="text-content-primary text-base">
        Entered mobile number [+{payload.countryCode} {payload.mobileNumber}] is
        already linked to an existing account.
      </p>
      <div className="flex flex-col gap-2">
        <h3 className="text-sm font-bold md:text-base">Linked account</h3>
        <div className="-mx-4 flex max-h-[30vh] flex-col gap-2 overflow-scroll px-4">
          {emails.map((option, index) => (
            <div
              className={`cursor-pointer select-none rounded-lg border border-white bg-white px-3 py-4 ${selectedEmail === option.uuid ? selectedEmailStyles : ""}`}
              onClick={() => handleSelect(option.uuid)}
              key={index}
            >
              <label className={labelStyles} htmlFor={option.uuid}>
                <input
                  id={option.uuid}
                  name="emails"
                  type="radio"
                  value={option.uuid}
                  className="mt-[4px] text-sm"
                  onChange={handleChange}
                />
                <p className="text-sm">{option.email}</p>
              </label>
              {selectedEmail === option.uuid && (
                <Button
                  key="login-btn"
                  modifier="primary"
                  onClick={handleLogin}
                  label="Login to linked account"
                  className="mt-4 w-full"
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <div>
        <p className="relative border-b-2">
          <span className="text-content-placeholder absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 bg-[#F8F9FD] px-2 text-xs">
            OR
          </span>
        </p>
        <Button
          key="continue-btn"
          modifier="tertiary"
          onClick={() => closePopup("continue")}
          label={
            siteProps?.site_map === "rexmonster"
              ? "Claim Number to Register"
              : "Continue with Registration"
          }
          className="mt-3 w-full"
        />
      </div>
    </div>
  );
};

export default ExistingEmails;
